export default ({}) => 
<div>
<h1>Other</h1>
</div>
